import $foreign from "./foreign.cjs";
var $$new = $foreign.new;
var read = $foreign.read;
var write = $foreign.write;
export { $$new as new, read, write };
